import React from "react";

import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";

import { Panel } from "../../../panel";
import { TemplatePageProps, LayoutPage } from "../../../types";
import { addRegisteredLayout, PanelSettings } from "../layoutDescriptions";
import { ThemeProvider } from "@material-ui/core/styles";
import { TemplatePanel } from "@ploy-lib/types";
import { columnsSummaryHeaderTheme, useStyles, actionsTheme } from "./styles";
import clsx from "clsx";
import FormStatus from "../../../components/FormStatus";
import { useAppLoad } from "../../../appLoadContext";

export type TwoColumnsPanels = {
	column1: TemplatePanel;
	column2: TemplatePanel;
	summaryHeader: TemplatePanel;
	actions: TemplatePanel;
	appActions: TemplatePanel;
};

export type TwoColumnsPanelKeys = keyof TwoColumnsPanels;
export type TwoColumnsPage = LayoutPage<
	TwoColumnsPanelKeys,
	TwoColumnsPanels
>;

type TwoColumnPanelSettings = Record<TwoColumnsPanelKeys, PanelSettings>;

const column1PanelSettings: PanelSettings = {
	editableOptions: {
		title: true,
		elevation: true,
		square: true
	}
};
const column2PanelSettings: PanelSettings = {
	editableOptions: {
		title: true,
		elevation: true,
		square: true
	}
};

const summaryHeaderPanelSettings: PanelSettings = {
	editableOptions: {
		title: false,
		elevation: true,
		square: true,
	}
};

const panels: TwoColumnPanelSettings = {
	summaryHeader: summaryHeaderPanelSettings,
	column1: column1PanelSettings,
	column2: column2PanelSettings,
	actions: {},
	appActions: {}
};

addRegisteredLayout({
	name: "TwoColumns",
	displayName: "TwoColumns",
	panels
});
const useTwoColumnsStyle = makeStyles(theme => ({
	twoColumnPadding: {
		padding: 0
	}
}));

export function TwoColumns(props: TemplatePageProps<TwoColumnsPage>) {
	const classes = useStyles(props);
	const twoColumnsStyle = useTwoColumnsStyle(props);
	const { header, panels } = props;

	const { summaryHeader, column1, column2, actions, appActions } =
		panels;

	const { vulcanContext } = useAppLoad();

	return (
		<Grid container spacing={2}>
			
			<Grid item xs={12}>
				<FormStatus />
			</Grid>
			<Grid item xs={12}>
				<Grid container>
					<Grid item md={8} xs={12}>
						<Grid item xs={12}>
							{column1 && (
								<Paper elevation={0}>
									{column1.panelTitle && (
										<Typography
											variant="h6"
											className={classes.mainSectionsHeader}
										>
											{column1.panelTitle}
										</Typography>
									)}
									<Panel
										className={clsx(
											classes.mainSections,
											twoColumnsStyle.twoColumnPadding
										)}
										{...column1}
									/>
								</Paper>
							)}
						</Grid>
						<Grid item xs={12}>
							{actions && vulcanContext !== "PostProcess" && (
								<ThemeProvider theme={actionsTheme}>
									<Panel
										
										{...actions}
									/>
								</ThemeProvider>
							)}
						</Grid>
					</Grid>
					<Grid item md={4} xs={12}>
						
					
							<Grid item xs={12}>
								{column2 && (
									<Paper elevation={0}>
										{column2.panelTitle && (
											<Typography
												variant="h6"
												className={classes.mainSectionsHeader}
											>
												{column2.panelTitle}
											</Typography>
										)}
										<Panel
											className={clsx(
												classes.mainSections,
												twoColumnsStyle.twoColumnPadding
											)}
											{...column2}
										/>
									</Paper>
								)}
							</Grid>
					</Grid>
				</Grid>
				
			</Grid>
		</Grid>
	);
}

